import styled from "styled-components";
export const ListContainer = styled.div`
  color: #f0eef2;
  font-family: Avenir Next;
  padding: 0 50px;
  & > ul {
    max-height: 75px;
    margin-bottom: 10px;
    overflow-y: auto;
  }
  & > p {
    margin-bottom: 10px;
  }
`;
export const UploadFiles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 0 40px;
  font-family: Raleway;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #f0eef2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  .label {
    border-radius: 30px;
    border: 1px solid #f0eef2;
    padding: 10px 25px;
    box-sizing: border-box;
    width: 130px;
    & label {
      display: flex;
      & > img {
        margin-right: 10px;
      }
    }
    & > input[type="file"] {
      display: none;
    }
  }
  .btn {
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      padding: 0 40px;
      box-sizing: border-box;
      border-radius: 30px;
      font-family: Avenir Next;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #f0eef2;
      border: 0;
      background: #e33aa9;
      cursor: pointer;
    }
  }

  .table-container {
    max-height: 200px;
    overflow-y: auto;
    .list-container {
      font-size: 12px;

      & {
        th,
        td {
          border: 1px solid white;
          padding: 5px;
        }
      }
    }
    & + * {
      margin-top: 10px;
    }
  }
`;